<template>
  <v-alert type="warning" class="mt-5"
    ><span class="white--text">{{ $t("global.processing") }}</span></v-alert
  >
</template>
<script>
export default {
  name: "EnrolmentCancel",

  props: ["id", "token"],

  created() {
    this.$store.dispatch("master/setLoader", true)

    axios
      .post(this.API_URL + "open/enrolment/cancel", {
        id: this.id,
        token: this.token
      })
      .then((res) => {
        let status = res.data.status

        this.$store.dispatch("master/setLoader", true)

        if (status == "ok") {
          this.$awn.success(this.$t("fe.enrolment.enrolment_cancel_ok"))
        } else {
          this.$awn.alert(this.$t("fe.enrolment.enrolment_cancel_error"))
        }

        this.$router.push("/auth/no/login")
      })
      .catch((err) => {
        this.$router.push("/auth/no/login")
      })
  }
}
</script>
